import { RouterProvider, createHashRouter } from "react-router-dom";
import NotFoundPage from "../404Page/404Page.jsx";
import Layout from "../Layout/Layout.jsx";
import Home from "../Home/Home.jsx";
import Login from "../Login/Login.jsx";
import Category from "../../Dashboard/Category/Category.jsx";
import Brand from "../../Dashboard/Brand/Brand.jsx";
import Product from "../../Dashboard/Product/Product.jsx";
import SubCategory from "../../Dashboard/SubCategory/SubCategory.jsx";
import Users from "../../Dashboard/Users/Users.jsx";
import Dashboard from "../../Dashboard/Dashboard.jsx";
import Register from './../Register/Register';
import WishList from "../WishList/WishList.jsx";
import Cart from './../Cart/Cart';
import ForgetPass from "../ForgetPass/ForgetPass.jsx";
import { ToastContainer } from "react-toastify";
import ResetPass from "../ResetPass/ResetPass.jsx";
import Details from "../Details/Details.jsx";
import CheckOut from "../CheckOut/CheckOut.jsx";
import ProtectedRouter from "../ProtectedRouter/ProtectedRouter.jsx";
import CategoryD from './../Category/Category';
import SubCategories from './../SubCategory/SubCategory';
import Brands from './../Brands/Brands';
import Orders from "../Orders/Orders.jsx";
import Products from "../Products/Products.jsx";
import Contact from "../Contact/Contact.jsx";


function App() {
  const routes = createHashRouter([
    {
      path: '/', element: <Layout />, children: [
        { index: true, element: <Home /> },
        {
          path: '/dashboard', element: <ProtectedRouter> <Dashboard /></ProtectedRouter>, children: [
            { path: '/dashboard/category', element: <Category /> },
            { path: '/dashboard/subCategory', element: <SubCategory /> },
            { path: '/dashboard/brand', element: <Brand /> },
            { path: '/dashboard/product', element: <Product /> },
            { path: '/dashboard/users', element: <Users /> },
          ]
        },
        { path: '/signin', element: <Login /> },
        { path: '/forgetPass', element: <ForgetPass /> },
        { path: '/resetPass', element: <ResetPass /> },
        { path: '/signup', element: <Register /> },
        { path: '/contact', element: <Contact /> },
        { path: '/wishlist', element: <ProtectedRouter ><WishList /></ProtectedRouter> },
        { path: '/cart', element: <ProtectedRouter ><Cart /></ProtectedRouter> },
        { path: '/checkout', element: <ProtectedRouter><CheckOut /></ProtectedRouter> },
        { path: '/orders', element: <ProtectedRouter><Orders /></ProtectedRouter> },
        { path: '/products/:id', element: <Details /> },
        { path: '/products', element: <Products /> },
        { path: '/categories/:id', element: <CategoryD /> },
        { path: '/subCategories/:id', element: <SubCategories /> },
        { path: '/brands/:id', element: <Brands /> },
        { path: '*', element: <NotFoundPage /> },
      ]
    }
  ])


  return (
    <div >
      <ToastContainer limit={1} hideProgressBar={true} autoClose={1500} position="top-center" />
      <RouterProvider router={routes} />
    </div>
  );
}

export default App;
